import { type EnvironmentVars } from "./environments.types";

/**
 * Interpolate ${VAR_NAME} references in a value using global environment vars.
 * - Cross-file lookup only (references resolve against globalVars, not sibling vars)
 * - Single-quoted values disable interpolation
 * - \$ escapes expansion
 * - Undefined refs resolve to empty string
 */
export function interpolateEnvVars(value: string, globalVars: EnvironmentVars): string {
	// Single-quoted values disable interpolation entirely
	if (value.startsWith("'") && value.endsWith("'")) {
		return value.slice(1, -1);
	}

	// Replace escaped \$ with a unique placeholder, interpolate, then restore
	const ESCAPED_DOLLAR = `__ESC_${crypto.randomUUID()}__`;
	let result = value.replace(/\\\$/g, ESCAPED_DOLLAR);

	// Match ${VAR_NAME} - standard dotenv-expand syntax
	result = result.replace(/\$\{([a-zA-Z_][a-zA-Z0-9_]*)\}/g, (_match, varName) => {
		return globalVars[varName] ?? "";
	});

	// Restore escaped dollars
	result = result.replaceAll(ESCAPED_DOLLAR, "$");

	return result;
}
